import { useRef } from 'react';
import { AutoSizer, List, WindowScroller } from 'react-virtualized';

import useScreenSize from '@/hooks/useScreenSize';
import InfiniteScroll from '@/shared-components/lists/components/InfiniteScroll';

import ArtistMgmtCard from './artist-mgmt-card/artist-mgmt-card.jsx';

export default function VirtualList({ fetchData, setFetchData, loadMoreData }) {
  const screenSize = useScreenSize();
  const listRef = useRef();

  // Puedes incluir funciones para actualizar algún estado del artista si se requiere
  function onUpdateArtist(galleryartistsId, updatedFields) {
    setFetchData({
      ...fetchData,
      data: fetchData.data.map((galleryartists) =>
        galleryartists._id === galleryartistsId ? { ...galleryartists, ...updatedFields } : galleryartists
      )
    });
  }

  return (
    <InfiniteScroll
      onLoadMore={loadMoreData}
      shouldLoadMore={fetchData.data.length < fetchData.totalDocs}
      offsetElements={3}
      listLength={fetchData.data.length}
    >
      {({ infiniteScrollAssigner }) => (
        <WindowScroller>
          {({ height, isScrolling, onChildScroll, scrollTop }) => (
            <AutoSizer disableHeight onResize={() => listRef.current.recomputeRowHeights()}>
              {({ width }) => (
                <List
                  autoHeight
                  width={width}
                  height={height}
                  isScrolling={isScrolling}
                  onScroll={onChildScroll}
                  scrollTop={scrollTop}
                  ref={listRef}
                  overscanRowCount={3}
                  rowCount={fetchData.data.length}
                  rowHeight={
                    screenSize.width <= 550
                      ? 95
                      : screenSize.width <= 1004
                        ? 94
                        : 95
                  }
                  rowRenderer={({ index, style }) => (
                    <div
                      key={fetchData.data[index]._id}
                      style={style}
                      ref={infiniteScrollAssigner(index)}
                    >
                      <ArtistMgmtCard
                        artistData={fetchData.data[index]}
                        onUpdateArtist={onUpdateArtist}
                      />
                    </div>
                  )}
                />
              )}
            </AutoSizer>
          )}
        </WindowScroller>
      )}
    </InfiniteScroll>
  );
}
